import React, { useEffect, useMemo, useState } from "react";
import { useForm, Controller } from "react-hook-form";
import { InputText } from "primereact/inputtext";
import { Dropdown } from "primereact/dropdown";
import { InputMask } from "primereact/inputmask";
import { classNames } from "primereact/utils";
import "./CompteEntreprise.scss";
import BtnBlanc from "Components/Boutons/BtnBlanc/btn-blanc";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { InputTextarea } from "primereact/inputtextarea";
import { Checkbox } from "primereact/checkbox";
import { Button } from "primereact/button";
import ModalCharte from "Components/Modal/ModalCharte/ModalCharte";
import Input from "react-phone-number-input/input";
import { isPossiblePhoneNumber } from "react-phone-number-input";
import axios from "axios";
import { useFetchGet, useFetchGetConditional } from "Services/api";
import { updateSecondaryTables } from "Redux/Actions/secondaryTablesActions";
import { BsCheck2Circle, BsXCircle } from "react-icons/bs";
import Modal from "Components/Modal/Modal";

const CompteEntreprise = (props) => {
  const [showMessage, setShowMessage] = useState(false);
  const [formData, setFormData] = useState({});
  const [visibleModalCharte, setVisibleModalCharte] = useState(false);
  const [isPartner, setIsPartner] = useState(false);
  const [verified, setVerified] = useState(false);

  const [companyCategory, setCompanyCategory] = useState("France");

  const structuresData = useFetchGet("/company_structures");
  const effectifData = useFetchGet("/company_total_staffs");
  const typeEntrepriseData = useFetchGet("/company_types", props.auth.token);
  const sectorData = useFetchGetConditional(
    "/sector_of_offers",
    props.auth.token,
    props.secondaryTables.sectorOfOffersData
  );

  //? Dénomination sociale des entreprises en France
  const frenchIdentificationNumberTypes = [
    { label: "SIRET", value: "SIRET" },
    { label: "SIREN", value: "SIREN" },
  ];

  const [identificationNumberType, setIdentificationNumberType] = useState(
    frenchIdentificationNumberTypes[0].value
  );

  useEffect(() => {
    sectorData.loaded &&
      props.handleUpdateSecondaryTables({
        sectorOfOffersData: sectorData.data,
      });
  }, [sectorData.loaded]);

  // constantes de l'utilisateur
  let defaultValues = {
    surname: "",
    firstname: "",
    email: "",
    telephone: "",
    description: "",
    siret: "",
    siren: "",
    companyUrl: "",
    rna: "",
    duns: "",
    companyName: "",
    size: "",
    structure: "",
    role: "",
    sector: "",
    country: "",
  };

  const {
    control,
    formState: { errors },
    handleSubmit,
    reset,
    setValue,
    getValues,
    trigger,
    // watch,
  } = useForm({ defaultValues });

  const onSubmit = () => {
    const data = getValues();
    setFormData(data);
    submitRequest(data);
    reset();
  };

  const getFormErrorMessage = (name) => {
    return (
      errors[name] && <small className="p-error">{errors[name].message}</small>
    );
  };

  useMemo(() => {
    if (verified === false && isPartner === false) {
      setValue("companyName", "");
      setValue("sector", "");
      setValue("size", "");
      setValue("companyUrl", "");
    }
    if (verified) setIsPartner(false);
    else if (isPartner) setVerified(false);
  }, [verified, isPartner]);

  const verifyNumber = async (value) => {
    let underScoreOccurence = value.split("_").length - 1;
    let formattedValue = value.replace(/\s/g, "");
    if (
      (companyCategory === "France" &&
        identificationNumberType === "SIRET" &&
        formattedValue.length == 14) ||
      (identificationNumberType === "SIREN" &&
        formattedValue.length == 9 &&
        underScoreOccurence === 0) ||
      (companyCategory !== "France" &&
        formattedValue.length == 9 &&
        underScoreOccurence === 0)
    ) {
      let company = await searchCompanyWithIdentificationNumber(formattedValue);
      if (company) {
        setIsPartner(true);
        setValue("companyName", company.name);
        setValue("description", company.description);
        setValue("companyUrl", company.companyUrl);
        company.structure &&
          setValue(
            "structure",
            structuresData.data.filter(
              (structure) => structure.id === company.structure.id
            )[0]
          );
        company.totalStaff &&
          setValue(
            "size",
            effectifData.data.filter(
              (effectif) => effectif.id === company.totalStaff.id
            )[0]
          );
        company.sector &&
          setValue(
            "sector",
            sectorData.data.filter(
              (secteur) => secteur.id === company.sector.id
            )[0]
          );
      } else {
        const companyInfos = await searchCompanyIdentificationNumberApi(
          formattedValue
        );

        companyInfos?.structure &&
          setValue("structure", companyInfos.structure);
        companyInfos?.companyName &&
          setValue("companyName", companyInfos.companyName);
        companyInfos?.siret &&
          getValues("siret", companyInfos.siret) === "" &&
          setValue("siret", companyInfos.siret);
        companyInfos?.siren &&
          getValues("siren", companyInfos.siren) === "" &&
          setValue("siren", companyInfos.siren);
        setIsPartner(false);
      }
    } else {
      setIsPartner(false);
      setVerified(false);
    }
  };

  const civilityData = [
    { label: "M", id: 1, code: "Monsieur" },
    { label: "Mme", id: 2, code: "Madame" },
  ];

  /**
   * Recherche une entreprise par son numéro d'identification (API Recruteur)
   *
   * @param {string} identificationNumber - Numéro d'identification de l'entreprise renseigné par l'utilisateur
   * @returns {object} - Données de l'entreprise
   */
  const searchCompanyWithIdentificationNumber = async (
    identificationNumber
  ) => {
    var url = new URL(
      `${process.env.REACT_APP_RECRUTEUR_API_URL}/api/companies`
    );

    identificationNumberType === "SIRET" &&
      url.searchParams.set("siret", identificationNumber);
    identificationNumberType === "SIREN" &&
      url.searchParams.set("siren", identificationNumber);
    var data = undefined;
    try {
      let response = await axios.get(url);
      data = response.data;
    } catch (error) {
      props.auth.toast?.current?.show({
        severity: "error",
        summary: "Erreur",
        detail: error?.response?.data?.detail || "Une erreur est survenue",
        life: 5000,
      });
      data = error;
    }
    return data[0];
  };

  /**
   * Recherche de l'entreprise par son SIRET (API sirene)
   *
   * (Uniquement si l'entreprise n'est pas déjà partenaire de Réseau Pro)
   *
   * @param {string} identificationNumber - Numéro d'identification de l'entreprise renseigné par l'utilisateur
   * @returns {object} - Données de l'entreprise
   */
  const searchCompanyIdentificationNumberApi = async (identificationNumber) => {
    var url = new URL(
      `${process.env.REACT_APP_RECRUTEUR_API_URL}/api/companies/identificationNumber/${identificationNumber}`
    );

    const companyData = await axios.get(url);

    if (companyData.status === 200 && companyData.data) {
      setVerified(true);
      return {
        companyName: companyData.data.name,
        structure:
          structuresData.data.find(
            (structure) => structure.label === companyData.data.structure
          ) || "",
        siret: companyData.data?.siret,
        siren: companyData.data?.siren,
      };
    } else {
      setVerified(false);
    }
  };

  const formatData = (data) => {
    let tempCompanyType = null;
    let formatData = {
      siret: data.siret.replace(/ /g, ""),
      siren: data.siren.replace(/ /g, ""),
      rna: data.rna.replace(/ /g, ""),
      duns: data.duns.replace(/ /g, ""),
      companyUrl: data.companyUrl,
      companyName: data.companyName,
      companyDescription: data.description,
      companySector: `api/sector_of_offers/${data.sector.id}`,
      recruiterFunction: data.role,
      country: "",
      firstname: data.firstname,
      surname: data.surname,
      email: data.email,
      telephone: data.telephone,
    };

    if (data.sector && data.sector.length > 0)
      formatData.companySector = `api/sector_of_offers/${data.sector.id}`;

    if (data.civility) formatData.recruiterCivility = data.civility.label;
    else formatData.recruiterCivility = "";

    switch (companyCategory) {
      case "France":
        tempCompanyType = typeEntrepriseData.data.filter(
          (type) => type.label === "Entreprise située en France"
        )[0].id;
        formatData.companyType = `api/company_types/${tempCompanyType}`;
        formatData.companyTotalStaff = `api/company_total_staffs/${data.size.id}`;
        formatData.companyStructure = `api/company_structures/${data.structure.id}`;
        formatData.country = "France";
        break;
      case "International":
        tempCompanyType = typeEntrepriseData.data.filter(
          (type) => type.label === "Entreprise internationale"
        )[0].id;
        formatData.companyType = `api/company_types/${tempCompanyType}`;
        // if (data.country !== "") formatData.recruiterCountry = data.country;
        break;
      case "Association":
        tempCompanyType = typeEntrepriseData.data.filter(
          (type) => type.label === "Association"
        )[0].id;
        formatData.companyType = `api/company_types/${tempCompanyType}`;
        formatData.companyTotalStaff = `api/company_total_staffs/${data.size.id}`;
        formatData.companyStructure = `api/company_structures/${
          structuresData.data.filter(
            (entreprise) => entreprise.label === "Association"
          )[0].id
        }`;
        // if (data.country !== "") formatData.recruiterCountry = data.country;
        break;
      default:
        break;
    }

    return formatData;
  };
  const submitRequest = (data) => {
    data = formatData(data);
    axios
      .post(
        `${process.env.REACT_APP_RECRUTEUR_API_URL}/api/recruiter_membership_requests`,
        data,
        {
          accept: "application/json",
        }
      )
      .then(() => {
        setShowMessage(true);
        setIsPartner(false);
        setVerified(false);
      })
      .catch((error) => {
        props.auth.toast.current.show({
          severity: "error",
          summary: "Erreur",
          detail:
            error.message ||
            "Une erreur est survenue lors de la création du compte",
          life: 4000,
        });
        reset();
      });
  };

  const getIdentificationNumberType = () => {
    if (companyCategory === "France") {
      return identificationNumberType === "SIRET" ? "siret" : "siren";
    }
    if (companyCategory === "International") return "duns";
    if (companyCategory === "Association") return "rna";
  };

  return (
    <div className="form-demo">
      <div className="test">
        <div className="flex justify-content-center">
          <div className="card">
            <form onSubmit={handleSubmit(onSubmit)} className="p-fluid">
              <div className="field">
                <h2>Vous êtes *</h2>

                <div className="checkboxes">
                  <div className="field checkbox">
                    <Checkbox
                      className="checkbox_french"
                      checked={companyCategory === "France"}
                      onChange={() => {
                        setCompanyCategory("France");
                        setVerified(false);
                        setIsPartner(false);
                      }}
                    />
                    <label htmlFor="french">Entreprise située en France</label>
                    {getFormErrorMessage("french")}
                  </div>
                  <div className="field checkbox">
                    <Checkbox
                      className="checkbox_international"
                      checked={companyCategory === "International"}
                      onChange={() => {
                        setCompanyCategory("International");
                        setVerified(false);
                        setIsPartner(false);
                      }}
                    />
                    <label htmlFor="international">
                      Une entreprise internationale
                    </label>
                    {getFormErrorMessage("international")}
                  </div>
                  <div className="field checkbox">
                    <Checkbox
                      className="checkbox_association"
                      checked={companyCategory === "Association"}
                      onChange={() => {
                        setCompanyCategory("Association");
                        setVerified(false);
                        setIsPartner(false);
                      }}
                    />
                    <label htmlFor="association">Une association</label>
                    {getFormErrorMessage("association")}
                  </div>
                </div>
              </div>

              <>
                {companyCategory === "France" && (
                  <div className="field">
                    <Dropdown
                      value={identificationNumberType}
                      options={frenchIdentificationNumberTypes}
                      className="identification_number"
                      onChange={(e) => {
                        setIdentificationNumberType(e.value);
                        setVerified(false);
                        setIsPartner(false);
                      }}
                    />
                  </div>
                )}

                <div className="field">
                  <h2>
                    {companyCategory === "Association"
                      ? "N° RNA de l'association *"
                      : companyCategory === "International"
                      ? "N° de DUNS de l'entreprise *"
                      : identificationNumberType === "SIRET"
                      ? "N° de SIRET de l'entreprise *"
                      : "N° de SIREN de l'entreprise *"}
                  </h2>
                  <Controller
                    name={getIdentificationNumberType()}
                    control={control}
                    rules={{ required: "Le numéro est requis" }}
                    render={({ field, fieldState }) => (
                      <InputMask
                        id={field.name}
                        mask={
                          companyCategory === "France" &&
                          identificationNumberType === "SIRET"
                            ? "999 999 999 99999"
                            : companyCategory === "International"
                            ? "99 999 9999"
                            : "999 999 999"
                        }
                        value={field.value}
                        placeholder={
                          companyCategory === "France" &&
                          identificationNumberType === "SIRET"
                            ? "999 999 999 99999"
                            : companyCategory === "International"
                            ? "99 999 9999"
                            : "999 999 999"
                        }
                        autoClear={false}
                        onChange={(e) => {
                          field.onChange(e.value);
                          verifyNumber(e.value);
                        }}
                        className={classNames({
                          "p-invalid": fieldState.invalid,
                        })}
                      />
                    )}
                  />
                  {getFormErrorMessage(getIdentificationNumberType())}
                </div>

                <div className="field">
                  <h2>
                    {companyCategory === "Association"
                      ? "Nom de l'association *"
                      : "Nom de l'entreprise *"}
                  </h2>
                  <Controller
                    name="companyName"
                    control={control}
                    rules={{ required: "Le nom est requis" }}
                    render={({ field, fieldState }) => (
                      <InputText
                        id={field.name}
                        readOnly={isPartner}
                        placeholder="Actimage ..."
                        {...field}
                        disabled={isPartner}
                        autoFocus
                        className={classNames({
                          "p-invalid": fieldState.invalid,
                        })}
                      />
                    )}
                  />
                  {getFormErrorMessage("companyName")}
                </div>

                {(isPartner === true || verified === true) && (
                  <div className="company_icon">
                    <div className="company_icon-already_partner">
                      <BsCheck2Circle />
                      <span>
                        {isPartner
                          ? "Votre entreprise est déjà partenaire de Réseau Pro !"
                          : verified
                          ? "Votre entreprise a été trouvée !"
                          : ""}
                      </span>
                    </div>
                  </div>
                )}
                {isPartner === false &&
                  verified === false &&
                  companyCategory === "France" && (
                    <div className="company_icon">
                      <div className="company_icon-not_found">
                        <BsXCircle />
                        <span>
                          Votre entreprise n&apos;a pas été trouvée. Veuillez
                          vérifier le numéro de SIRET/SIREN.
                        </span>
                      </div>
                    </div>
                  )}
                <>
                  <div className="field">
                    <h2>
                      {companyCategory === "Association"
                        ? "Description de l'association *"
                        : "Description de l'entreprise *"}
                    </h2>
                    <Controller
                      name="description"
                      control={control}
                      rules={{
                        required: !isPartner
                          ? "La description est requise"
                          : false,
                      }}
                      render={({ field, fieldState }) => (
                        <InputTextarea
                          id={field.name}
                          readOnly={isPartner}
                          placeholder="Description de l'entreprise..."
                          {...field}
                          className={classNames({
                            "p-invalid": fieldState.invalid,
                          })}
                        />
                      )}
                    />
                    {getFormErrorMessage("description")}
                  </div>

                  <div className="field">
                    <h2>
                      {companyCategory === "Association"
                        ? "Site internet de l'association *"
                        : "Site internet de l'entreprise *"}
                    </h2>
                    <Controller
                      name="companyUrl"
                      control={control}
                      rules={{
                        required: !isPartner
                          ? "Le site internet est requis"
                          : false,
                      }}
                      render={({ field, fieldState }) => (
                        <InputText
                          id={field.name}
                          readOnly={isPartner}
                          disabled={isPartner}
                          placeholder="https://..."
                          {...field}
                          className={classNames({
                            "p-invalid": fieldState.invalid,
                          })}
                        />
                      )}
                    />
                    {getFormErrorMessage("companyUrl")}
                  </div>

                  {/* <div className="field">
                      <h2>Pays de l&apos;entreprise</h2>
                      <Controller
                        name="country"
                        control={control}
                        render={({ field, fieldState }) => (
                          <Dropdown
                            id={field.name}
                            value={field.value}
                            options={data}
                            placeholder="France, ..."
                            disabled={companyCategory === "France"}
                            onChange={(e) => field.onChange(e.value)}
                            className={classNames({
                              "p-invalid": fieldState.invalid,
                            })}
                          />
                        )}
                      />
                      {getFormErrorMessage("country")}
                    </div> */}

                  <div className="ask_connexion_company">
                    <div className="field">
                      <h2>Structure de l&apos;entreprise *</h2>
                      <Controller
                        name="structure"
                        control={control}
                        rules={{
                          required:
                            "La structure de l'entreprise est requise" |
                            (companyCategory === "France"),
                        }}
                        render={({ field, fieldState }) => (
                          <Dropdown
                            id={field.name}
                            value={field.value}
                            optionLabel="label"
                            readOnly={isPartner}
                            options={structuresData?.data?.filter(
                              (structure) => structure.label !== "Association"
                            )}
                            placeholder="PME, TPE, ..."
                            disabled={
                              companyCategory === "Association" ||
                              companyCategory === "International" ||
                              (isPartner && companyCategory === "France")
                            }
                            onChange={(e) => field.onChange(e.value)}
                            className={classNames({
                              "p-invalid": fieldState.invalid,
                            })}
                          />
                        )}
                      />
                      {getFormErrorMessage("structure")}
                    </div>
                    <div className="field">
                      <h2>Effectif *</h2>
                      <Controller
                        name="size"
                        control={control}
                        rules={{
                          required:
                            "L'effectif est requis" |
                            (companyCategory !== "International"),
                        }}
                        render={({ field, fieldState }) => (
                          <Dropdown
                            id={field.name}
                            value={field.value}
                            readOnly={isPartner}
                            optionLabel="label"
                            options={effectifData?.data}
                            disabled={
                              companyCategory === "International" || isPartner
                            }
                            placeholder="Nombre de salariés"
                            onChange={(e) => field.onChange(e.value)}
                            className={classNames({
                              "p-invalid": fieldState.invalid,
                            })}
                          />
                        )}
                      />
                      {getFormErrorMessage("size")}
                    </div>
                  </div>
                </>

                <div className="field">
                  <h2>Secteur de l&apos;entreprise</h2>
                  <Controller
                    name="sector"
                    control={control}
                    render={({ field, fieldState }) => (
                      <Dropdown
                        id={field.name}
                        value={field.value}
                        placeholder="Programmation, publicité..."
                        optionLabel="label"
                        showClear
                        filter
                        disabled={isPartner}
                        filterBy="label"
                        options={sectorData?.data?.sort((a, b) =>
                          a?.label.localeCompare(b?.label)
                        )}
                        onChange={(e) => field.onChange(e.value)}
                        className={classNames({
                          "p-invalid": fieldState.invalid,
                          "dropdown-s": true,
                        })}
                      />
                    )}
                  />
                  {getFormErrorMessage("sector")}
                </div>

                <div className="field">
                  <h2>Civilité</h2>
                  <Controller
                    name="civility"
                    control={control}
                    render={({ field }) => (
                      <Dropdown
                        id={field.name}
                        value={field.value}
                        optionLabel="label"
                        options={civilityData}
                        placeholder="Monsieur, Madame"
                        onChange={(e) => field.onChange(e.value)}
                      />
                    )}
                  />

                  {getFormErrorMessage("civility")}
                </div>

                <div className="ask_connexion_name">
                  <div className="field">
                    <h2>Prénom *</h2>
                    <Controller
                      name="firstname"
                      control={control}
                      rules={{ required: "Le prénom est requis" }}
                      render={({ field, fieldState }) => (
                        <InputText
                          id={field.name}
                          {...field}
                          placeholder="Marie, Arthur..."
                          //   autoFocus
                          className={classNames({
                            "p-invalid": fieldState.invalid,
                          })}
                        />
                      )}
                    />
                    {getFormErrorMessage("firstname")}
                  </div>
                  <div className="field">
                    <h2>Nom *</h2>
                    <Controller
                      name="surname"
                      control={control}
                      rules={{ required: "Le nom est requis" }}
                      render={({ field, fieldState }) => (
                        <InputText
                          id={field.name}
                          placeholder="Dupont..."
                          {...field}
                          autoFocus
                          className={classNames({
                            "p-invalid": fieldState.invalid,
                          })}
                        />
                      )}
                    />
                    {getFormErrorMessage("surname")}
                  </div>
                </div>

                <div className="field">
                  <h2>
                    {companyCategory === "Association"
                      ? "Fonction au sein de l'association *"
                      : "Fonction au sein de l'entreprise *"}
                  </h2>
                  <Controller
                    name="role"
                    control={control}
                    rules={{ required: "La fonction est requise" }}
                    render={({ field, fieldState }) => (
                      <InputText
                        id={field.name}
                        placeholder="PDG, chargé de communication ..."
                        {...field}
                        autoFocus
                        className={classNames({
                          "p-invalid": fieldState.invalid,
                        })}
                      />
                    )}
                  />
                  {getFormErrorMessage("role")}
                </div>

                <div className="ask_connexion_coordinates">
                  <div className="field">
                    <h2>Adresse mail professionnelle *</h2>
                    <Controller
                      name="email"
                      control={control}
                      rules={{
                        required: "L'adresse mail est requise",
                        pattern: {
                          value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i,
                          message: "Adresse mail invalide",
                        },
                      }}
                      render={({ field, fieldState }) => (
                        <InputText
                          id={field.name}
                          placeholder="hello123@gmail.com"
                          {...field}
                          className={classNames({
                            "p-invalid": fieldState.invalid,
                          })}
                        />
                      )}
                    />
                    {getFormErrorMessage("email")}
                  </div>
                  <div className="field">
                    <h2>Numéro de téléphone *</h2>
                    <Controller
                      name="telephone"
                      control={control}
                      rules={{
                        validate: (value) =>
                          value
                            ? isPossiblePhoneNumber(value) ||
                              "Numéro de téléphone invalide"
                            : true,
                      }}
                      render={({ field }) => (
                        <Input
                          id={field.name}
                          {...field}
                          placeholder="+33 6 00 00 00 00"
                          className="p-inputtext p-component"
                        />
                      )}
                    />

                    {getFormErrorMessage("telephone")}
                  </div>
                </div>
              </>
              <BtnBlanc
                btnTexte="Envoyer"
                btnAction={async (e) => {
                  e.preventDefault();
                  if (verified || isPartner || companyCategory !== "France") {
                    const result = await trigger();
                    if (result) setVisibleModalCharte(!visibleModalCharte);
                  } else {
                    props.auth.toast.current.show({
                      severity: "error",
                      summary: "Erreur",
                      detail: "Le numéro de SIRET/SIREN est invalide",
                      life: 4000,
                    });
                  }
                }}
              />
            </form>
            {visibleModalCharte && (
              <ModalCharte
                visibleModal={visibleModalCharte}
                setVisibleModal={setVisibleModalCharte}
                btnRefuse={() => {
                  setVisibleModalCharte(false);
                  props.setAuthEntrepriseVisible(false);
                }}
                btnAction={() => {
                  onSubmit();
                }}
              >
                <div className="description">
                  <ModalCharte />
                </div>
              </ModalCharte>
            )}
          </div>
        </div>
      </div>
      <Modal
        visible={showMessage}
        setVisible={setShowMessage}
        header="Succès"
        blockScroll
        height="auto"
        width="30vw"
        className="modal recruiter__request"
      >
        <div className="recruiter__request__container">
          <i
            className="pi pi-check-circle"
            style={{ fontSize: "3rem", color: "var(--green-500)" }}
          ></i>
          <h5>Création de compte terminée !</h5>
          <p style={{ lineHeight: 1.5 }}>
            <br />
            Votre compte est enregistré sous le nom de{" "}
            <b>{formData?.firstname}</b> <b>{formData?.surname}</b>.
            <br />
            <br />
            Un mail vous sera envoyé à <b>{formData?.email}</b> une fois votre
            compte activé.
          </p>
          <Button
            label="OK"
            className="p-button-text"
            style={{
              //? Centrer le bouton
              marginLeft: "auto",
              marginRight: "auto",
            }}
            autoFocus
            onClick={() => {
              setShowMessage(false);
              props.setAuthEntrepriseVisible(false);
            }}
          />
        </div>
      </Modal>
    </div>
  );
};

CompteEntreprise.propTypes = {
  setAuthEntrepriseVisible: PropTypes.func,

  auth: PropTypes.object,
  secondaryTables: PropTypes.object,
  handleUpdateSecondaryTables: PropTypes.func,
};

const mapStateToProps = (state) => ({
  auth: state.auth,
  secondaryTables: state.secondaryTables,
});

const mapDispatchToProps = (dispatch) => ({
  handleUpdateSecondaryTables: (value) => {
    dispatch(updateSecondaryTables(value));
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(CompteEntreprise);
